var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import DataService from "./data.service";
import CookieService from "./cookie.service";
var CookieStatusService = /** @class */ (function () {
    function CookieStatusService() {
        this.dataService = DataService.getInstance();
        this.cookieService = CookieService.getInstance();
        this.cookieKey = '';
        this.subscribers = [];
    }
    Object.defineProperty(CookieStatusService.prototype, "CookieKey", {
        set: function (cookieKey) {
            this.cookieKey = cookieKey;
        },
        enumerable: true,
        configurable: true
    });
    CookieStatusService.getInstance = function () {
        if (!CookieStatusService.instance) {
            CookieStatusService.instance = new CookieStatusService();
        }
        return CookieStatusService.instance;
    };
    CookieStatusService.prototype.isOldData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var cookieSave, cookieSaveJson, tempCookieGroupStatus;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cookieSave = this.cookieService.readCookie(this.cookieKey);
                        if (!cookieSave) {
                            return [2 /*return*/, true];
                        }
                        cookieSaveJson = JSON.parse(this.cookieService.readCookie(this.cookieKey));
                        return [4 /*yield*/, this.getCookieGroupStatus()];
                    case 1:
                        tempCookieGroupStatus = _a.sent();
                        return [2 /*return*/, cookieSaveJson.some(function (element) {
                                var tempCookieGroupStatusIndex = tempCookieGroupStatus.findIndex(function (ele) { return ele.id === element.id; });
                                if (tempCookieGroupStatusIndex < 0) {
                                    return true;
                                }
                                return (element.updated_at !== tempCookieGroupStatus[tempCookieGroupStatusIndex].updated_at);
                            })];
                }
            });
        });
    };
    CookieStatusService.prototype.loadOldStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var tempCookieGroupStatus, cookieSave, cookieSaveJson;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCookieGroupStatus()];
                    case 1:
                        tempCookieGroupStatus = _a.sent();
                        cookieSave = this.cookieService.readCookie(this.cookieKey);
                        if (!cookieSave) {
                            return [2 /*return*/];
                        }
                        cookieSaveJson = JSON.parse(cookieSave);
                        cookieSaveJson.forEach(function (element) {
                            var tempCookieGroupStatusIndex = tempCookieGroupStatus.findIndex(function (ele) { return ele.id === element.id; });
                            tempCookieGroupStatus[tempCookieGroupStatusIndex].status = element.status;
                        });
                        this.cookieGroupStatus = tempCookieGroupStatus;
                        return [2 /*return*/];
                }
            });
        });
    };
    CookieStatusService.prototype.toggleCookieGroupStatus = function (cookieGroupId) {
        return __awaiter(this, void 0, void 0, function () {
            var tempCookieGroupStatus, cookieGroup;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCookieGroupStatus()];
                    case 1:
                        tempCookieGroupStatus = _a.sent();
                        cookieGroup = tempCookieGroupStatus.findIndex(function (ele) { return ele.id === cookieGroupId; });
                        tempCookieGroupStatus[cookieGroup].status = !tempCookieGroupStatus[cookieGroup].status;
                        this.cookieGroupStatus = tempCookieGroupStatus;
                        this.saveToCookie();
                        return [2 /*return*/];
                }
            });
        });
    };
    CookieStatusService.prototype.acceptAllCookieGroups = function () {
        return __awaiter(this, void 0, void 0, function () {
            var tempCookieGroupStatus;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCookieGroupStatus()];
                    case 1:
                        tempCookieGroupStatus = _a.sent();
                        tempCookieGroupStatus.forEach(function (ele) {
                            ele.status = true;
                        });
                        this.cookieGroupStatus = tempCookieGroupStatus;
                        this.update();
                        this.saveToCookie();
                        return [2 /*return*/];
                }
            });
        });
    };
    CookieStatusService.prototype.getCookieGroupStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.cookieGroupStatus) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.dataService.initData];
                    case 1:
                        data = _a.sent();
                        this.cookieGroupStatus = data.cookiegroups;
                        this.cookieGroupStatus = this.cookieGroupStatus.map(function (ele) {
                            ele.status = ele.required;
                            return ele;
                        });
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.cookieGroupStatus];
                }
            });
        });
    };
    CookieStatusService.prototype.subscribe = function (fn) {
        this.subscribers.push(fn);
    };
    CookieStatusService.prototype.update = function () {
        this.subscribers.forEach(function (subscriber) {
            subscriber();
        });
    };
    CookieStatusService.prototype.saveToCookie = function () {
        return __awaiter(this, void 0, void 0, function () {
            var tempCookieGroupStatus, newTempCookieGroupStatus;
            return __generator(this, function (_a) {
                tempCookieGroupStatus = this.cookieGroupStatus;
                newTempCookieGroupStatus = [];
                tempCookieGroupStatus.forEach(function (tempCookie) {
                    newTempCookieGroupStatus.push({
                        id: tempCookie.id,
                        updated_at: tempCookie.updated_at,
                        status: tempCookie.status
                    });
                });
                this.cookieService.createCookie({
                    key: this.cookieKey,
                    value: newTempCookieGroupStatus,
                    hostOnly: true,
                });
                return [2 /*return*/];
            });
        });
    };
    CookieStatusService.prototype.refreshCookie = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.cookieGroupStatus = null;
                        return [4 /*yield*/, this.getCookieGroupStatus()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return CookieStatusService;
}());
export default CookieStatusService;



//////////////////
// WEBPACK FOOTER
// ./service/cookie-status.service.tsx
// module id = null
// module chunks = 